import React from 'react';
import { BellIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';

function Notifications() {
  // Mock notifications data
  const notifications = [
    {
      id: 1,
      title: 'Daily Streak Bonus',
      message: 'You earned 50 coins for your 3-day streak!',
      type: 'success',
      time: '2 hours ago',
      read: false
    },
    {
      id: 2,
      title: 'Quiz Completed',
      message: 'You scored 8/10 on the Science Quiz',
      type: 'info',
      time: '5 hours ago',
      read: true
    },
    {
      id: 3,
      title: 'Spin Wheel Win',
      message: 'Congratulations! You won 100 coins!',
      type: 'success',
      time: '1 day ago',
      read: true
    },
    {
      id: 4,
      title: 'New Challenge',
      message: 'Complete 5 quizzes to earn 200 coins',
      type: 'info',
      time: '2 days ago',
      read: true
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-dark-800 rounded-2xl shadow-lg p-6">
        <div className="flex items-center space-x-4 mb-6">
          <div className="p-3 bg-primary-100 dark:bg-primary-900/20 rounded-lg">
            <BellIcon className="h-6 w-6 text-primary-600 dark:text-primary-400" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Notifications
            </h2>
            <p className="text-gray-500 dark:text-gray-400">
              Stay updated with your progress
            </p>
          </div>
        </div>

        <div className="space-y-4">
          {notifications.map((notification) => (
            <div
              key={notification.id}
              className={`p-4 rounded-xl ${
                notification.read
                  ? 'bg-gray-50 dark:bg-dark-700'
                  : 'bg-primary-50 dark:bg-primary-900/20'
              }`}
            >
              <div className="flex items-start space-x-4">
                <div className="p-2 rounded-lg">
                  {notification.type === 'success' ? (
                    <CheckCircleIcon className="h-5 w-5 text-green-500" />
                  ) : (
                    <XCircleIcon className="h-5 w-5 text-blue-500" />
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h3
                      className={`font-medium ${
                        notification.read
                          ? 'text-gray-900 dark:text-white'
                          : 'text-primary-600 dark:text-primary-400'
                      }`}
                    >
                      {notification.title}
                    </h3>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                      {notification.time}
                    </span>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300 mt-1">
                    {notification.message}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Notifications; 